import React from "react";
import { Button } from "./ui";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AuthPageLayout, { AuthSuccessIcon } from "./AuthPageLayout";

function AccountCreated() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation("translation");
  const email = location.state?.email || "";

  return (
    <AuthPageLayout cardClassName="auth-page-card--status">
      <div className="auth-status-body">
        <AuthSuccessIcon />
        <h1 className="auth-page-card__title">
          {t("accountCreated.title", { defaultValue: "Account Created!" })}
        </h1>
        <p>
          {t("accountCreated.welcome", {
            defaultValue: "Welcome to Loops. Your account has been created successfully.",
          })}
        </p>
        <p>
          {email ? (
            <>
              {t("accountCreated.confirmationSentPrefix", {
                defaultValue: "A confirmation has been sent to",
              })}{" "}
              <strong className="auth-status-email">{email}</strong>.
            </>
          ) : (
            t("accountCreated.confirmationSentGeneric", {
              defaultValue: "A confirmation link has been sent to your email.",
            })
          )}
        </p>
      </div>

      <Button
        color="primary"
        size="md"
        className="auth-submit"
        onClick={() => navigate("/")}
      >
        {t("accountCreated.backToLogin", { defaultValue: "BACK TO LOGIN" })}
      </Button>
    </AuthPageLayout>
  );
}

export default AccountCreated;
